 <!-- components/ChapterTree.vue -->
<template>
    <el-scrollbar class="chapter-tree">
      <el-menu :default-active="activeKey" @select="handleSelect">
        <div v-for="chapter in chapters" :key="chapter.id">
          <el-sub-menu :index="chapter.id">
            <template #title>
              <span>{{ chapter.name }}</span>
            </template>
            <el-menu-item
              v-for="section in chapter.sections"
              :key="section.id"
              :index="`${chapter.id}-${section.id}`"
            >
              {{ section.name }}
              <el-tag size="small" type="info" v-if="section.knowledgePoints?.length">
                {{ section.knowledgePoints.length }}个知识点
              </el-tag>
            </el-menu-item>
          </el-sub-menu>
        </div>
      </el-menu>
    </el-scrollbar>
  </template>
  
  <script setup>
  import { ref, defineEmits } from 'vue'
  
  const emit = defineEmits(['chapter-change'])
  
  const activeKey = ref('')
  
  const chapters = [
    {
      id: 'ch1',
      name: '第一章 集合与常用逻辑用语',
      sections: [
        { id: 's1', name: '1.1 集合的概念', knowledgePoints: ['元素与集合关系', '集合表示法'] },
        { id: 's2', name: '1.2 集合间的基本关系', knowledgePoints: ['子集', '真子集'] },
        { id: 's3', name: '1.3 集合的基本运算', knowledgePoints: ['并集', '交集', '补集'] },
        { id: 's4', name: '1.4 充分条件与必要条件' },
        { id: 's5', name: '1.5 全称量词与存在量词' },
      ]
    },
    {
      id: 'ch2',
      name: '第二章 一元二次函数、方程和不等式',
      sections: [
        { id: 's6', name: '2.1 等式性质与不等式性质' },
        { id: 's7', name: '2.2 基本不等式' },
        { id: 's8', name: '2.3 二次函数与一元二次方程、不等式' },
      ]
    },
  ]
  
  const handleSelect = (key) => {
    activeKey.value = key
    emit('chapter-change', key)
  }
  </script>
  
  <style scoped>
  .chapter-tree {
    height: calc(100vh - 120px);
    border-right: 1px solid #eee;
    padding: 10px;
  }
  </style>